import React from "react";

import * as S from "./styles";
import { IProps } from "./types";
import NoResultIcon from "./images/no-result.png";

const NoResult: React.FC<IProps> = ({
  // destructure props here if needed
}: IProps) => {
  return (
    <S.Wrapper>
      <S.Icon 
        src={NoResultIcon}
        width="360"
        height="360"
      />
      <p>Sorry, no matches found for your request.</p>
      <p>Try again or shop new arrivals.</p>
    </S.Wrapper>
  )
};

export { NoResult }